export default "__VITE_ASSET__Cbl8VJLy__"